import React from "react";
import { KukoList } from "../screens";
import ContactPeoplesList from "../screens/kokuListing/ContactPeoplesList";

const protectedRoutes = [
    { path: "/enquiry-listing", element: <ContactPeoplesList /> },

    { path: "/listing", element: <KukoList /> },

]

export default protectedRoutes